import './SectionPromoBanner.scss';

const SectionPromoBanner = () => {
  return (
    <section className="section-promo-banner flex lg:py-[60px] lg:px-[80px] md:px-[20px] px-[16px] py-[32px] items-start lg:gap-[40px] self-stretch">
      <img
        src="https://d391nxox3m93fb.cloudfront.net/fitta_site_images/promotion.webp"
        alt=""
        className="object-cover w-full"
      />
    </section>
  );
};

export default SectionPromoBanner;
